import DataRoomNodeTagAndVersion from './DataRoomNodeTagAndVersion.component';

export default DataRoomNodeTagAndVersion;
